export const bezier =
  'transition: 0.3s cubic-bezier(0.175, 0.885, 0.320, 1.275) all';
